import React from 'react';

// import '@/styles/global.css'
export default function Layout({ children }: { children: React.ReactNode }) {
  return <>{children}</>;
}
